/* global axios */
import ApiClient from './ApiClient';

// The system's API reference: the OpenAPI spec as a Postman collection, generated by
// `rails postman:build` and served by the dashboard so it never drifts from the API it describes.
class ApiReference extends ApiClient {
  constructor() {
    super('api_reference', { accountScoped: true });
  }

  postmanCollection() {
    return axios.get(`${this.url}/postman`, { responseType: 'blob' });
  }
}

export default new ApiReference();
